import React, { useEffect, useState } from "react";
import { useTable, useSortBy } from "react-table";
import Skeleton from "@mui/material/Skeleton";
import { useTranslation } from "react-i18next";
import { detectWebDeviceType } from "../../utils";

function Table({
  columns,
  data,
  pagination, // { current, pageSize, onChange }
  setPagination,
  onRowClick,
  selectedRowIndex,
  isLoadingData,
}) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const deviceType = detectWebDeviceType();


  // console.log("PAGINATION", pagination);
  // console.log("DATA ------>", data);

  

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
  } = useTable(
    {
      columns,
      data,
    },
    useSortBy
  );

  // Manage loading display
  useEffect(() => {
    if (data.length > 0) {
      setIsLoading(false);
    } else if (isLoadingData) {
      setIsLoading(true);
    }
  }, [data, isLoadingData]);

  if (isLoading) {
    return (
      <div className="p-4">
        {[...Array(6)].map((_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            width="100%"
            height={index % 2 === 0 ? 40 : 60}
            className="mb-3"
          />
        ))}
      </div>
    );
  }

  return (
    <>
      {data.length > 0 && (
        <table {...getTableProps()} className="w-full">
          <thead className="bg-[#C9ECF7] text-zinc-800 font-semibold text-lg text-left capitalize whitespace-nowrap">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    key={column.id}
                    className="px-6 py-3 text-center"
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr
                  {...row.getRowProps()}
                  key={row.id}
                  onClick={() => onRowClick(row.original)}
                  className={`cursor-pointer ${selectedRowIndex === i ? "bg-gray-200" : ""
                    } border-b border-gray-300`}
                >
                  {row.cells.map((cell) => (
                    <td
                      {...cell.getCellProps()}
                      key={cell.column.id}
                      className={`px-6 ${deviceType === "tablet" ? "py-2" : "py-3"} text-center`}
                    >
                      <div className={`${deviceType === "tablet" ? "text-base" : "text-lg"} text-gray-900`}>
                        {cell.render("Cell")}
                      </div>
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

       <footer className="flex justify-center text-lg self-center px-5 mt-2  w-full">
        <div className="flex gap-5 text-center text-black font-semibold w-2/12">
           <button
            onClick={() => setPagination((prevValue) => prevValue - 20)}
            // disabled={pagination <= 0}
            disabled={pagination <= 0 || isLoadingData}
            className="p-2 rounded-full bg-gray-200"
            style={{ width: "40px", height: "40px" }}
          >
            &lt;
          </button>
          <div className="flex-auto my-auto">
            {t("Results")}{" "}
            <strong>
              {pagination + 1}-{pagination + data.length}
            </strong>
          </div>
          <button
            onClick={() => setPagination((prevValue) => prevValue + 20)}
            // disabled={data?.length < 10}
            disabled={data?.length < 10 || isLoadingData}
            className="p-2 rounded-full bg-gray-200"
            style={{ width: "40px", height: "40px" }}
          >
            &gt;
          </button>
        </div>
      </footer>

      {/* Pagination Footer */}
      {/* <footer className="flex justify-center items-center text-lg font-semibold mt-4">
        <div className="flex gap-5 items-center">
          <button
            onClick={() => pagination.onChange(Math.max(1, pagination.current - 1))}
            disabled={pagination.current === 1 || isLoadingData}
            className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 transition"
            style={{ width: "40px", height: "40px" }}
          >
            &lt;
          </button>

          <span>
            {t("Results")}{" "}
            <strong>
              {(pagination - 1) * pagination.pageSize + 1} –{" "}
              {(pagination- 1) * pagination.pageSize + data.length}
            </strong>
          </span>

          <button
            onClick={() => pagination.onChange(pagination.current + 1)}
            disabled={data.length < pagination.pageSize || isLoadingData}
            className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 transition"
            style={{ width: "40px", height: "40px" }}
          >
            &gt;
          </button>
        </div>
      </footer> */}
    </>
  );
}

export default Table;
